<template>
  <div>
    <v-dialog
      v-model="existingQantas"
      scrollable
      persistent
      :overlay="false"
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card>
        <v-title>{{ title }}</v-title>
        <v-flex xs12>
          <customer-table
            v-if="existingQantas"
            :customer-data="customerData || []"
            :order-type="3"
            :loading="loading"
            :total-items="totalItems"
            @existingOrder="existingOrder"
            @emptyCustomerData="closeServices()"
            @cancelOrder="$emit('closed')"
            @updatePage="updateCustomerList"
          ></customer-table>
          <v-flex v-else>You have no eligible customers.</v-flex>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="light-grey" @click="$emit('closed')">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import customerTable from '@/components/customerTable';
const { mapGetters: mapOrderGetters } = createNamespacedHelpers(`orders`);
export default {
  name: 'QantasListCustomers',
  components: {
    customerTable,
  },
  props: {
    existingQantas: { type: Boolean, required: true },
  },
  data() {
    return {
      customerData: [],
      loading: false,
      title: 'Customers with QBR Plans',
      totalItems: undefined,
      pagination: {
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  methods: {
    ...mapActions('orders/qantas', ['listCustomers', 'existingQBRCustomers']),
    getEligible() {
      let vm = this;
      vm.loading = true;
      vm.title = 'Customers Eligible for QBR Plans';
      vm.customerData = [];
      vm.getCustomers({
        includeNonContract: false,
        pagination: vm.pagination,
        keyword: '',
      });
    },
    updateCustomerList(data) {
      let vm = this;
      vm.loading = true;
      vm.pagination.pageSize = data.pageSize;
      vm.pagination.pageNo = data.pageNo;
      vm.customerData = [];

      vm.getCustomers({
        dealerID: data.dealerID,
        includeNonContract: false,
        pagination: vm.pagination,
        keyword: data.keyword,
      });
    },
    getCustomers(payload) {
      let vm = this;
      vm.listCustomers(payload)
        .then((data) => {
          vm.customerData = data.customers;
          vm.totalItems = data.total;
          vm.dealerID = data.dealerID;

          vm.loading = false;
        })
        .catch((err) => {});
    },
    getExisting() {
      let vm = this;
      vm.loading = true;
      vm.title = 'Customers with QBR Plans';
      vm.customerData = [];
      vm.existingQBRCustomers()
        .then((data) => {
          vm.customerData = data;
          vm.loading = false;
        })
        .catch((err) => {});
    },
    existingOrder(orderID) {
      let vm = this;
      //vm.dialog = false;
      vm.retrieved = true;
      vm.loading = true;
      // vm.setResidential(true);
      this.getOrder(orderID)
        .then((order) => {
          if (order) {
            if (vm.message.httpStatus === 200) {
              vm.setResidential(
                order.customerDetails
                  ? order.customerDetails.companyID == 0
                  : false
              );
              vm.loading = false;

              // if (order.orderStatus > 0)
              //   vm.$router.push({
              //     path: "order-summary"
              //   });
            }
          }
        })
        .catch((err) => {
          vm.setMessage(
            new httpError({
              message: 'Unable to get order: ' + err.message,
              httpStatus: 500,
            })
          );
        });
    },
  },
  computed: {
    ...mapOrderGetters(['isDirectSales']),
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
